import { useQuery } from "@apollo/client";
import { NOTIFICATIONS } from "../notification.queries";
import {
  NotificationsQuery,
  NotificationsQueryVariables,
} from "../../../__generated__/NotificationsQuery";

export const useNotifications = (variables: NotificationsQueryVariables) => {
  return useQuery<NotificationsQuery, NotificationsQueryVariables>(NOTIFICATIONS, {
    variables,
  });
};
